import { createEvent, createStore, sample } from '@lib/state-engine';

export const MODES: Modes = [
  { value: 'map', label: 'Карта' },
  { value: 'list', label: 'Список' },
];

export const setViewMode = createEvent<ViewMode>();

export const $selectedViewMode = createStore(MODES[0]);

type Mode = {
  value: ViewMode;
  label: string;
};

type Modes = Mode[];

export type ViewMode = 'map' | 'list';

sample({
  clock: setViewMode,
  fn: (mode) => {
    if (mode === 'map') {
      return MODES[0];
    }

    if (mode === 'list') {
      return MODES[1];
    }

    return MODES[0];
  },
  target: $selectedViewMode,
});
